$(document).ready(function () {
  var $wrapper = $('[data-pdp-enquiry]');
  var $openBtn = $('[data-pdp-enquiry-open]')
  var $closeBtn = $('[data-php-enquiry-close]')
  var $nameInput = $('[data-pdp-enquiry-input-name]');
  var $submitButton = $('[data-pdp-enquiry-submit]');

  const klaviyoListId = window.theme.global_klaviyo_list_id;
  const siteCode = window.theme.global_klaviyo_site_code;

  if ($wrapper.length) {
    $openBtn.on('click', function () {
      $wrapper.css("display", "flex")
        .hide()
        .fadeIn(500);

      $nameInput.focus();
    });

    $closeBtn.on('click', function () {
      $wrapper.fadeOut(500);
    });

    function pushProfileToKlaviyo(profile) {
      var settings = {
        async: true,
        crossDomain: true,
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        data: {
          "g": klaviyoListId,
          "$fields": "$first_name,$last_name,$source,Customer Type"
        }
      };

      var fieldKeys = Object.entries(profile).map((keyValue) => {
        settings.data[keyValue[0]] = keyValue[1];
        return keyValue[0]
      }).join(",");
      settings.data["$fields"] = fieldKeys;

      $.ajax(settings)
        .fail(function () {
          console.log("Error pushing profile to Klaviyo.");
        });
    };

    $submitButton.on('click', function (e) {
      var $form = $(this).closest('form');

      var formSelectors = {
        country: {
          selector: "[name=\"contact[location]\"]"
        },
        customerType: {
          selector: "[name=\"contact[Enquiry Type]\"]:checked"
        },
        state: {
          selector: "[name=\"contact[State]\"]"
        },
        organisation: {
          selector: "[name=\"contact[Company]\"]"
        }
      };

      var enquiryFieldsToTrack = [
        {
          selector: "[name=\"contact[Product]\"]",
          klaviyoFieldName: "product"
        },
        {
          selector: "[name=\"contact[Product Url]\"]",
          klaviyoFieldName: "url"
        },
        {
          selector: "[name=\"contact[body]\"]",
          klaviyoFieldName: "enquiry"
        },
        {
          selector: "[name=\"contact[Enquiry Type]\"]:checked",
          klaviyoFieldName: "enquiry_type"
        },
        {
          selector: "[name=\"contact[Preferred Contact Method]\"]:checked",
          klaviyoFieldName: "preferred_contact_method"
        }
      ];

      var identityFieldsToTrack = [
        {
          selector: "[name=\"contact[First Name]\"]",
          klaviyoFieldName: "$first_name"
        },
        {
          selector: "[name=\"contact[Last Name]\"]",
          klaviyoFieldName: "$last_name"
        },
        {
          selector: "[name=\"contact[email]\"]",
          klaviyoFieldName: "$email"
        },
        {
          selector: "[name=\"contact[phone]\"]",
          klaviyoFieldName: "$phone_number"
        },
        {
          selector: "[name=\"contact[Enquiry Type]\"]:checked",
          klaviyoFieldName: "Customer Type"
        }
      ];

      var identityKeyValue = {};
      var enquiryEventKeyValue = {};
      var signUpToNewsletter = $("[name=\"contact[tags]\"]").is(":checked");
      var customerType = $(formSelectors.customerType.selector).val();
      var organisation = $(formSelectors.organisation.selector).val();

      if (customerType === "Commercial" && organisation.length) {
        identityFieldsToTrack.push({
          selector: "[name=\"contact[Company]\"]",
          klaviyoFieldName: "$organization"
        });
      }

      identityFieldsToTrack.forEach(function (identityField) {
        var $element = $form.find(identityField.selector);
        var elementType = $($element).attr("type");
        var elementValue = $element.val();
        var elementValue = elementType === "checkbox" ? $element.is(":checked") : $element.val();
        identityKeyValue[identityField.klaviyoFieldName] = elementValue;
      });

      if (siteCode === "au") {
        var state = $(formSelectors.state.selector).val();

        if (state !== "International") {
          identityKeyValue["$region"] = state;
          identityKeyValue["$country"] = "Australia";
        } else {
          identityKeyValue["$country"] = "International";
        }
      }

      if (siteCode === "sg") {
        var country = $(formSelectors.country.selector).val();
        identityKeyValue["$country"] = country;
      }

      enquiryFieldsToTrack.forEach(function (enquiryField) {
        var $element = $form.find(enquiryField.selector);
        var elementValue = $element.val();
        enquiryEventKeyValue[enquiryField.klaviyoFieldName] = elementValue;
      });

      if (signUpToNewsletter) {
        identityKeyValue["$source"] = "Product Enquiry Form";
        pushProfileToKlaviyo(identityKeyValue);
      }

      // Define Klaviyo Object
      var klaviyo = window.klaviyo || [];
      // Identify Profile
      klaviyo.identify(identityKeyValue, onIdentifyCompleteCallback);
      // Push Product Data to Klaviyo
      function onIdentifyCompleteCallback() {
        klaviyo.push(["track", "Product Enquiry", enquiryEventKeyValue]);
      }


      window.dataLayer.push({
        event: 'Product Enquiry',
        productName: $form.find('[name="contact[Product]"]').val(),
        productCategory: $(this).data('productType')
      });
    });

  }
});


